export default class LoginInfo {
    usercode: string;
    password: string;
    rememberMe: boolean;
    autoLogin: boolean;
}
